import type { RecordView } from '@kit/sync/types/record-view';
import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import { NO_STORE } from '../config/no-store';
import type { ShoppingFilter } from '../schemas/shopping-filter';

/** Entries of the chosen store (or without one) and category. */
export function filterShopping(
  list: readonly RecordView<ShoppingItem>[],
  { store, category }: ShoppingFilter,
): RecordView<ShoppingItem>[] {
  return list.filter(({ data }) => {
    const own = data.store?.trim() ?? '';
    if (store === NO_STORE ? own !== '' : store !== '' && own !== store) return false;
    return category === '' || data.category === category;
  });
}
